import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { DEFAULT_MESSAGES, resolveMessage } from "./constants/messages";

const defaultContextValue = {
  messages: DEFAULT_MESSAGES,
  msg: (key, values) => resolveMessage(DEFAULT_MESSAGES, key, values),
};

const MessageContext = createContext(defaultContextValue);

export function MessageProvider({ children, messages }) {
  const [serverMessages, setServerMessages] = useState({});

  useEffect(() => {
    if (typeof messages === "string") {
      let cancelled = false;
      fetch(messages)
        .then((res) => {
          if (!res.ok) throw new Error(`Messages fetch failed: ${res.status}`);
          return res.json();
        })
        .then((data) => {
          if (!cancelled && data && typeof data === "object") {
            setServerMessages(data);
          }
        })
        .catch((err) => {
          console.warn("Failed to load server messages:", err);
        });
      return () => {
        cancelled = true;
      };
    }
  }, [messages]);

  const dictionary = useMemo(
    () => ({ ...DEFAULT_MESSAGES, ...serverMessages, ...(typeof messages === "object" ? messages : {}) }),
    [serverMessages, messages]
  );

  const value = useMemo(
    () => ({
      messages: dictionary,
      msg: (key, values) => resolveMessage(dictionary, key, values),
    }),
    [dictionary]
  );

  return (
    <MessageContext.Provider value={value}>{children}</MessageContext.Provider>
  );
}

export function useMessage() {
  const { msg } = useContext(MessageContext);
  return msg;
}

export default MessageProvider;